import { ICreateVideoStudioState } from './createVideoStudioModalContext';
import { CreateVideoStudioActionTypes, TCreateVideoStudioAction } from '../createVideoStudioModalActions';

export const createVideoStudioReducer = (
	state: ICreateVideoStudioState,
	action: TCreateVideoStudioAction,
): ICreateVideoStudioState => {
	switch (action.type) {
		case CreateVideoStudioActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case CreateVideoStudioActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateVideoStudioActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateVideoStudioActionTypes.RESET_FIELDS:
			return {
				...state,
				name: '',
				dataForSubmit: null,
			};
		default:
			return state;
	}
};
